function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.000000, -172.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(39.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.7,12.2966667 L39.025,12.2966667 L39.025,17 L32.7,17 L32.7,12.2966667 Z M25,6.205 L31.325,6.205 L31.325,10.9083333 L25,10.9083333 L25,6.205 Z M25,-4.05719902e-12 L47,-4.05719902e-12 L47,4.78833333 L25,4.78833333 L25,-4.05719902e-12 Z M40.4,12.2966667 L47,12.2966667 L47,17 L40.4,17 L40.4,12.2966667 Z M25,12.2966667 L31.325,12.2966667 L31.325,17 L25,17 L25,12.2966667 Z M32.7,6.205 L39.025,6.205 L39.025,10.9083333 L32.7,10.9083333 L32.7,6.205 Z M40.4,6.205 L47,6.205 L47,10.9083333 L40.4,10.9083333 L40.4,6.205 Z"
})))));

const SvgIcFabricView = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFabricView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-fabric-view.0fd56044.svg";
export { ForwardRef as ReactComponent };